import { addDays, addMonths, addYears, format, startOfDay, startOfMonth, startOfYear } from "date-fns";

function generateDividerDates(range, dividerUnit) {
  const marks = [];
  const end = range.end.getTime();

  let cursor;
  let stepper;
  let backStepper;
  let labelFmt;

  if (dividerUnit === "year") {
    cursor = startOfYear(range.start);
    stepper = (date) => addYears(date, 1);
    backStepper = (date) => addYears(date, -1);
    labelFmt = "yyyy";
  } else if (dividerUnit === "month") {
    cursor = startOfMonth(range.start);
    stepper = (date) => addMonths(date, 1);
    backStepper = (date) => addMonths(date, -1);
    labelFmt = "MMMM yyyy";
  } else {
    cursor = startOfDay(range.start);
    stepper = (date) => addDays(date, 1);
    backStepper = (date) => addDays(date, -1);
    labelFmt = "EEE, MMM d";
  }

  while (cursor.getTime() > range.start.getTime()) {
    cursor = backStepper(cursor);
  }
  while (cursor.getTime() < range.start.getTime()) {
    cursor = stepper(cursor);
  }
  cursor = backStepper(cursor);

  const extendedEnd = stepper(new Date(end)).getTime();
  while (cursor.getTime() <= extendedEnd) {
    marks.push({
      ts: cursor.getTime(),
      label: format(cursor, labelFmt),
    });
    cursor = stepper(cursor);
  }

  return marks;
}

export function generateTimelineDividers(range, preset) {
  return generateDividerDates(range, preset.dividerUnit);
}
